import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IStar } from '@interfaces/star.interface';

export interface StarEvent {
  event: Event;
  star: IStar;
}

@Component({
  selector: 'ark-ui-star',
  templateUrl: './ui-star.component.html',
  styleUrls: ['./ui-star.component.scss'],
})
export class UiStartComponent {
  @Input()
  public star!: IStar;

  @Input()
  public size: 'medium' | 'avatar' | 'large' = 'medium';

  @Output()
  public itemMove: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  public itemClick: EventEmitter<StarEvent> = new EventEmitter<StarEvent>();

  @Output()
  public itemOver: EventEmitter<unknown> = new EventEmitter<unknown>();

  public onClick(event: MouseEvent): void {
    this.itemClick.emit({ event, star: this.star });
  }

  public onMove(event: MouseEvent): void {
    this.itemMove.emit(event.offsetX);
  }

  public onOver(): void {
    this.itemOver.emit();
  }
}
